import { Flex, HelpTip, Link } from "@amzn/storm-ui";

import { WORKBENCH_SIM_TICKET } from "../../../../constants/links";
import { StyledFailedText } from "../../../common/styled.components";

export const WbVisualizationFailedAction: React.FunctionComponent<{
    executionId: string;
}> = ({ executionId }) => {
    return (
        <Flex alignItems="center">
            <StyledFailedText>Failed to compile</StyledFailedText>
            <HelpTip id={`${executionId}-visualization-fail`}>
                Compiled insight failed to generate. Please raise a ticket{" "}
                <Link target="_blank" href={WORKBENCH_SIM_TICKET}>
                    here
                </Link>{" "}
            </HelpTip>
        </Flex>
    );
};
